import styles from '../styles/loading.module.scss'

export default function Loading() {
	return <div className={styles.loadingContainer}>
		<h3 className="text-center mt-4">Please wait a moment...</h3>
		<img src="/images/loading_left.svg" alt="illustration" className={styles.leftImage} />
		<div className={styles.centerImage_container}>
			<img src="/images/loading_center.svg" alt="illustration" className={styles.centerImage} />
		</div>
		<img src="/images/loading_right.svg" alt="illustration" className={styles.rightImage} />
	</div>
}